module.exports = __webpack_public_path__ + "assets/img/aboutus_img_ci.14f20cea.svg";